<template>
  <AppIconButton :label="message || `Copy ${label}`" @keydown.enter.native.stop @keydown.space.native.stop @click.stop="copy">
    <i class="pi pi-clipboard" aria-hidden="true" />
    <span v-if="message" class="mailgun-copy__status" role="status">{{ message }}</span>
  </AppIconButton>
</template>

<script>
import AppIconButton from '@/components/AppIconButton.vue'
import CopyButton from '@/views/tech-support/integrations/CopyButton.vue'

export default {
  name: 'MailgunCopyButton',
  extends: CopyButton,
  components: { AppIconButton }
}
</script>

<style lang="scss" scoped>
.mailgun-copy__status { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; }
</style>
